export const text2html = (text) => {
  let htmlConverted = text.replace(
    /<b>/g,
    '<span class="bold">',
  );
  htmlConverted = htmlConverted.replace(/<\/b>/g, '</span>');
  return { __html: htmlConverted };
};

export const numberPrice2ClientStringPrice = (number, decimals = 2, decimalChar = ',', thousandChar = '.') => {
  let res = number;
  res = parseFloat(res).toFixed(decimals);
  res = res.replace('.', decimalChar);
  const splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  res = splitNum.join(decimalChar);
  return res;
}

export const replacehttp2https = (input) => {
  if (input) {
    return input.replace('http://', 'https://');
  }
  return null;
}

export const externalLink = (link) => {
  if (link.indexOf('http:') > -1
    || link.indexOf('https:') > -1
    || link.indexOf('mailto:') > -1
  ) {
    if (link.indexOf('movistar.es') > -1
      || link.indexOf('col10mgmt.tsm.inet') > -1
    ) {
      return {
        spaExternal: true,
        siteExternal: false,
      }
    }

    return {
      spaExternal: false,
      siteExternal: true,
    }
  }
  
  return {
    spaExternal: false,
    siteExternal: false,
  }
}

export const camelize = (str) => {
  if (str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  }
  return null;
}
export const convertToKebabCase = (string) => {
  if (string) {
    return string.replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .toLowerCase();
  }

  return null;
}

export const normalizeAccent = (str) => {
  let strReturn = null;
  if (str) {
    strReturn = str;
    strReturn = strReturn.replace(/á/g, 'a');
    strReturn = strReturn.replace(/é/g, 'e');
    strReturn = strReturn.replace(/í/g, 'i');
    strReturn = strReturn.replace(/ó/g, 'o');
    strReturn = strReturn.replace(/ú/g, 'u');
  }
  return strReturn;
}

export const normalizeString = (str) => {
  let strReturn = null;
  if (str) {
    strReturn = str.toLowerCase();
    strReturn = normalizeAccent(strReturn);
    strReturn = strReturn.replace(/[^a-z]/g, '');
  }
  return strReturn;
}


export const whichAnimationEvent = () => {
  const el = document.createElement('fakeelement');
  const transitions = {
    animation: 'animationend',
    OAnimation: 'oAnimationEnd',
    MozAnimation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
  }

  let transition = null;

  Object.keys(transitions).forEach((t) => {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
}


export const whichTransitionEvent = () => {
  const el = document.createElement('fakeelement');
  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  }

  let transition = null;

  Object.keys(transitions).forEach((t) => {
    if (typeof el.style[t] !== 'undefined') {
      transition = transitions[t];
    }
  });
  return transition;
}

export const htmlEncode = (s) => {
  const el = document.createElement('div');
  let str = s;
  str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
  str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
  el.innerHTML = str;
  const returnString = el.textContent;
  return returnString;
}
